export class CubeIntegrationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCubeIntegrationToken() {
    return this.#http.get('/cube-integration/token');
  }

  async getCubeIntegrationRequestsHistory() {
    return this.#http.get('/cube-integration/requests-history');
  }

  async createCubeIntegrationRequestsHistory(body) {
    return this.#http.post('/cube-integration/requests-history', body);
  }
}
